import { Header } from '@mairistem/composants';

import { formatMonetaire } from '@/utils';
import { ModalConfirm } from '../Autre';

type ModalConfirmTransfertProps = {
  loading: boolean;
  type: 'PES' | 'ORMC' | 'titre';
  total: number;
  totalReste: number;
  onCancel: () => void;
  onConfirm: () => void;
};

const ModalConfirmTransfert = (props: ModalConfirmTransfertProps) => {
  const { loading, type, total, totalReste, onCancel, onConfirm } = props;

  return (
    <ModalConfirm
      loading={loading}
      header={
        type === 'PES'
          ? 'Transfert des impayés par titrage individuel (PES ASAP)'
          : type === 'ORMC'
            ? 'Transfert des impayés par rôle (ORMC)'
            : 'Transfert du titre global accompagnant le rôle des impayés'
      }
      content={
        <Header as="h4">
          <Header.Content>
            <Header.Subheader>
              {(type === 'ORMC' || type === 'PES') &&
                (type === 'PES' ? (
                  total <= 1 ? (
                    <>
                      <b>Une facture</b> impayée va être transférée en comptabilité pour un montant
                      de
                    </>
                  ) : (
                    <>
                      <b>{total} factures</b> impayées vont être transférées en comptabilité pour un
                      montant total de
                    </>
                  )
                ) : total <= 1 ? ( // ORMC
                  <>
                    <b>Une facture</b> impayée va être transférée à votre poste comptable pour un
                    montant de
                  </>
                ) : (
                  <>
                    <b>{total} factures</b> impayées vont être transférées à votre poste comptable
                    pour un montant total de
                  </>
                ))}
              {type !== 'titre' && <b> {formatMonetaire(totalReste, 2, true)}</b>}
              {type === 'titre' && (
                <>
                  Un titre global d&apos;un montant de <b>{formatMonetaire(totalReste, 2, true)}</b>{' '}
                  va être transféré en comptabilité
                </>
              )}
            </Header.Subheader>
            <br />
            Êtes-vous sûr de vouloir effectuer cette action ?
          </Header.Content>
        </Header>
      }
      cancelText="Annuler"
      confirmText="Confirmer le transfert"
      onCancel={onCancel}
      onConfirm={onConfirm}
    />
  );
};

export default ModalConfirmTransfert;
